export const ONBOARDING_STEP_1 = 'onboarding-step-1';
export const ONBOARDING_STEP_2 = 'onboarding-step-2';
export const ONBOARDING_STEP_3 = 'onboarding-step-3';
